"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableWrapper = void 0;
const KeepTheRhythm_1 = require("../KeepTheRhythm");
const app_1 = require("app");
class ExpandableWrapper {
    constructor({ ctaClass, data, minHeight, padding = null }) {
        this.isExpandeble = false;
        this.wrapperClass = 'expand-wrapper';
        this.enabledWrapperClass = 'expand-wrapper-enabled';
        this.maxHeightProp = 'maxHeight';
        this.ctaClass = ctaClass;
        this.tableData = data;
        this.minHeight = minHeight;
        this.padding = padding || KeepTheRhythm_1.KeepTheRhythmComponent.baseline * 2;
    }
    initExpandableWrapper(params) {
        this.wrapper = params.wrapper;
        this.el = params.element;
        this.baseHeight = this.minHeight();
        if (!this.wrapper.classList.contains(this.wrapperClass)) {
            this.wrapper.classList.add(this.wrapperClass);
        }
        this.addExpandButton(params.onClickHandler, params.tableType, params.tableUniqueId);
    }
    // use UpdateExpand() after filter data and resize
    updateExpand(diffHeight) {
        this.baseHeight = this.minHeight();
        if (diffHeight) {
            this.increaseHeight(diffHeight);
        }
        this.showExpandButton();
    }
    increaseHeight(diffHeight) {
        this.changeHeight(diffHeight, (height, diff) => height + diff);
    }
    decreaseHeight(diffHeight) {
        this.changeHeight(diffHeight, (height, diff) => height - diff);
    }
    changeHeight(diffHeight, cb) {
        if (!this.isExpandeble || !diffHeight) {
            return;
        }
        if (!this.baseHeight || !cb) {
            this.baseHeight = this.minHeight();
        }
        if (cb) {
            this.baseHeight = cb(this.baseHeight, diffHeight);
        }
        if (!this.wrapper.classList.contains('open')) {
            this.wrapper.style[this.maxHeightProp] = this.baseHeight + 'px';
        }
    }
    addExpandButton(onClickHandler, tableType, tableUniqueId) {
        const expandWrapper = $(`
      <div class="expand-wrapper-button-wrap bg-white bottom-0 left-0 absolute right-0 text-center transition-shadow duration-150 ease-in-out shadow-[0_-20px_80px_17px_#fff] hidden group-[.expand-wrapper-enabled]:block group-[.open]:shadow-none pt-2xs pb-2xs">
        <button
          class="bg-transparent border-0 min-h-[48px] cta no-ktr ${this.ctaClass} expand-button"
          aria-expanded="false"
          aria-controls="${tableType}-expand-content"
          id="${tableType}-expand-button-${tableUniqueId}"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="df-icon p-2xs transition-transform duration-300 rotate-90 group-[.open]:rotate-270">
              <use href="/static/icons/chevron-right-outline.svg#chevron-right-outline" />
          </svg>
        </button>
      </div>
    `);
        expandWrapper.find('button').click(() => {
            const contentHeight = $(this.wrapper).find($(this.el)).innerHeight();
            const isTableCollapsed = !this.wrapper.classList.contains('open');
            if (isTableCollapsed) {
                this.wrapper.style[this.maxHeightProp] = `${contentHeight + KeepTheRhythm_1.KeepTheRhythmComponent.baseline * 2}px`;
                this.wrapper.style.paddingBottom = `${this.padding}px`;
                setTimeout(() => {
                    this.wrapper.style[this.maxHeightProp] = '';
                    this.wrapper.classList.toggle('open');
                }, 300);
            }
            else {
                this.wrapper.style[this.maxHeightProp] = `${contentHeight + KeepTheRhythm_1.KeepTheRhythmComponent.baseline * 2}px`;
                this.wrapper.classList.toggle('open');
                const scrollTopValue = this.wrapper.getBoundingClientRect().top + scrollY - window.innerHeight / 3;
                this.wrapper.style[this.maxHeightProp] = `${this.baseHeight || this.minHeight()}px`;
                this.wrapper.style['paddingBottom'] = '';
                app_1.scrollService.GoToPosition(app_1.ScrollDirectionEnum.Top, scrollTopValue, app_1.ScrollDurationEnum.Fast);
            }
            expandWrapper.find('button').attr('aria-expanded', isTableCollapsed.toString());
            if (onClickHandler) {
                onClickHandler(isTableCollapsed);
            }
        });
        $(this.wrapper).append(expandWrapper);
        this.showExpandButton();
    }
    /**
     * Use when content height was changed
     * Logic for different cases:
     * 1) add expand button when content is bigger than max visible height
     * 2) hide expand button when content is smaller than max visible height
     * 3) add css property max-height when there is expand button and it is not opened
     * 4) delete css property max-height when there is expand button and it is opened
     * 5) delete css property max-height when there is no expand button
     */
    showExpandButton() {
        const isContentBiggerThenContainer = $(this.wrapper).find($(this.el)).innerHeight() > this.baseHeight && this.baseHeight > 200; // to avoid showing expand button for small tables
        if (isContentBiggerThenContainer) {
            this.wrapper.classList.add(this.enabledWrapperClass);
            this.isExpandeble = true;
            if (this.wrapper.classList.contains('open')) {
                this.wrapper.style[this.maxHeightProp] = '';
                return;
            }
            this.wrapper.style[this.maxHeightProp] = this.baseHeight + 'px';
            return;
        }
        this.isExpandeble = false;
        this.wrapper.classList.remove(this.enabledWrapperClass);
        this.wrapper.style[this.maxHeightProp] = '';
    }
}
exports.ExpandableWrapper = ExpandableWrapper;
